module.exports = __webpack_public_path__ + "media/assets/icons/angle-double-up-9e2ec4909bb435ea4d6568b79c502303.svg";